import React from 'react';
import {NavLink, Navigate, Outlet} from 'react-router-dom';
import {classNames} from '../../utils/common';

const StatsLayout = () => {
    return (
        <div className="relative w-full mx-auto max-w-7xl py-6 pl-8 pr-4">
            <div className="mb-4 flex items-center">
                <p className="text-xs text-gray-700 mr-2">
                    Type
                </p>
                <div className="inline-flex" role="tablist" aria-label="Stats pages">
                    <NavLink
                        to="/stats/models"
                        role="tab"
                        className={({isActive}) => classNames(
                            isActive
                                ? 'bg-gray-300 text-indigo-900'
                                : 'bg-gray-100 text-gray-600 hover:bg-gray-200',
                            'px-3 py-1 text-xs font-medium rounded-l-full'
                        )}
                    >
                        Stats models
                    </NavLink>
                    <NavLink
                        to="/stats/freestyle"
                        role="tab"
                        className={({isActive}) => classNames(
                            isActive
                                ? 'bg-gray-300 text-indigo-900'
                                : 'bg-gray-100 text-gray-600 hover:bg-gray-200',
                            'px-3 py-1 text-xs font-medium rounded-r-full'
                        )}
                    >
                        Freestyle Statistic
                    </NavLink>
                </div>
            </div>
            <Outlet/>
        </div>
    );
};

export const StatsIndexRedirect = () => <Navigate to="models" replace/>;

export default StatsLayout;
